var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SplitViewTemplate',{attrs:{"screenConfig":_vm.setScreenConfig,"backButtonRoute":'/settings/company',"dataModel":_vm.formModel,"formConfig":_vm.setFormConfig}})}
var staticRenderFns = []

export { render, staticRenderFns }